/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
//Export Preferences
export const EXPORT_PREFERENCES = "Export Preferences"
export const EXPROT_TXT = "Export"
export const ORIENTATION = "Orientation"
export const SIZE = "Size"

//Export Options
export const EXPORT_AS_XML = "Export as XML"
export const EXPORT_AS_PDF = "Export as PDF"

//Orientation
export const LANDSCAPE = "Landscape"
export const PORTRAIT = "Portrait"

//Size
export const A0 = "A0"
export const A1 = "A1"
export const A2 = "A2"
export const A3 = "A3"
export const A4 = "A4"
export const A5 = "A5"
export const LEGAL = "Legal"
export const LETTER = "Letter"
export const TABLOID = "Tabloid"

//Buttons
export const EXPORT_XML = "Export XML"
export const EXPORT_PDF = "Export PDF"
export const CANCEL = "Cancel"